import { gql } from 'apollo-boost';

export const GET_WRAPPED_STATS = gql`
    query {
        getWrappedStats {
            tasksCompleted
            videosSaved
            totalSaved
            memberSince
            topTopic {
                entityName
                entityType
                count
            }
        }
    }
`;
